import { ReactNode } from 'react'

export type SidebarGroupProps = {
  children?: ReactNode
}

export function SidebarGroup({ children }: SidebarGroupProps) {

  return (
    <div className="flex flex-col p-stack-tight gap-stack-tight">
      { children }
    </div>
  )
}
